module.exports = __webpack_public_path__ + "media/images/articles/work_experience_resume/thumb-58dded6879ad051f592b4663be9a3d3a.png";